import { Component, Input, OnInit } from '@angular/core';
import { Menu } from '../../interfaces/menu.interface';
import { Dropdown } from '../../interfaces/dropdown.interface';
import { RoblexCollapsedSidepanelService } from '../collapsed-sidepanel/collapsed-sidepanel.service';
import { HeaderCollapsedSidepanelComponent } from '../header-collapsed-sidepanel/header-collapsed-sidepanel.component';

@Component({
    selector: 'roblex-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @Input() hasContainer = false;
    @Input() menus: Menu[];
    @Input() dropdows: Dropdown[];
    @Input() username: string;

    constructor(
        private roblexCollapsedSidepanelService: RoblexCollapsedSidepanelService
    ) {}

    ngOnInit(): void {}

    onClickMenu(item: Menu): void {
        if (item?.isRouteActive) {
            item?.isRouteActive(item);
        }
        if (item?.callbackAction) {
            item?.callbackAction(item);
        }
    }
    
    onClickToggle() {
        this.roblexCollapsedSidepanelService.show(
            HeaderCollapsedSidepanelComponent,
            {
                data: {
                    menus: this.menus,
                    dropdows: this.dropdows,
                },
            }
        );
    }
}
